import React from 'react';
import PageBanner from '../../layout/PageBanner';
import { Link } from 'react-router-dom';

const Agenda = (props) => (
  <div>
    <PageBanner title="Agenda" img="banner-agenda.JPG">
      <Link to="/">Home</Link>
      <Link to="/Agenda">Agenda</Link>
    </PageBanner>

    <section className="about-ds">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 section-header03">
            <h2 className="flacso-azul">Nuestra <span>Agenda</span></h2>
          </div>
        </div>
      </div>
    </section>

    <section className="all-course-wrapper events-style02">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="events-block">
              <div className="row">

                {props.eventos.length > 0 &&
                  props.eventos.map((evento, index) =>
                    <div className="col-sm-12 fade-in" key={index}>
                      <div className="event2-single">
                        <div className="row">
                          <div className="col-sm-2 event-date">
                            <span>{evento.fields.Fecha.substring(8, evento.fields.Fecha.length)}</span>
                            <span>{evento.fields.Fecha.substring(0, 7)}</span>
                          </div>
                          <div className="col-sm-3 event-thumb">
                            <img src={evento.fields.Imagen[0].url} alt="" className="img-responsive" />
                          </div>
                          <div className="col-sm-7 event-info">
                            <h3>{evento.fields.Titulo}</h3>
                            <p className="event-td">
                              <span><i className="fa fa-clock-o"></i>{evento.fields.Fecha}</span>
                            </p>
                            <p>{evento.fields.Descripcion}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
);

export default Agenda;
